/* src/app/modules/spare-parts/spare-parts-page/spare-parts-page.component.scss */
:host {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sp-container {
  display: flex;
  flex-flow: row nowrap;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}
app-widgets-service-parts {
  margin-top: 1rem;
}
#graphs-container {
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  margin-top: 1rem;
}
#graphs-container sh-card:nth-of-type(1) {
  height: 252px;
}
app-spare-parts-filter {
  border-bottom: 1px solid rgba(0, 0, 0, var(--opacity-4));
  padding-bottom: 0.5rem;
  margin-bottom: 0;
}
api-call-gate {
  margin-top: 1rem;
}
app-widgets-service-parts {
  margin-top: 1rem;
}
.empty-state-container {
  width: 100%;
}
.empty-state-parts {
  height: 25.188rem;
}
.empty-state-tickets {
  height: 39.938rem;
}
.empty-state-graph header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.empty-state-graph header sh-text {
  width: fit-content;
}
.empty-state-graph header sh-text:first-of-type {
  font-weight: 700;
}
.empty-state-graph .graph-empty-state-body {
  border-radius: 0.25rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: calc(100% - 2px);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-state-graph .graph-empty-state-body sh-text {
  width: fit-content;
}
.empty-state-graph .graph-empty-state-body .no-data-available {
  font-size: 1rem;
}
/*# sourceMappingURL=spare-parts-page.component.css.map */
